import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";

/** HIS項目患者氏名を変換する */
export class PtNameBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_NAME";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const values = hisInfoItems.filter(x => x.name === PtNameBehavior.Key).map(x => x.value);
    const ptName = values.map(x => StringUtility.convertKanaFromHalfToFull(x));
    return new HisInformationTextValue(PtNameBehavior.Key, ptName);
  }
}
